import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=104e87ce&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"
import style0 from "./goods.vue?vue&type=style&index=0&id=104e87ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104e87ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('104e87ce')) {
      api.createRecord('104e87ce', component.options)
    } else {
      api.reload('104e87ce', component.options)
    }
    module.hot.accept("./goods.vue?vue&type=template&id=104e87ce&scoped=true", function () {
      api.rerender('104e87ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commodityreference/pricingmanagement/goods.vue"
export default component.exports